import { render, staticRenderFns } from "./PublicationsListMore.vue?vue&type=template&id=779d17b9"
import script from "./PublicationsListMore.vue?vue&type=script&lang=js"
export * from "./PublicationsListMore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports